var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 11 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38 6.945c-.801 0-1.454-.67-1.454-1.495 0-.825.653-1.496 1.455-1.496s1.454.671 1.454 1.496-.652 1.495-1.454 1.495m0-4.132c-1.432 0-2.596 1.183-2.596 2.637S3.949 8.087 5.38 8.087c1.431 0 2.596-1.183 2.596-2.637S6.812 2.813 5.38 2.813M5.38 13.392a25.195 25.195 0 0 1-1.83-2.288c-1.47-2.083-2.246-3.95-2.246-5.4 0-4.082 3.12-4.4 4.076-4.4 3.783 0 4.077 3.368 4.077 4.4 0 2.87-2.921 6.402-4.077 7.688M9.04 1.294C8.105.46 6.805 0 5.38 0 3.957 0 2.657.46 1.72 1.294.595 2.297 0 3.822 0 5.704c0 4.098 4.717 8.9 4.917 9.103a.652.652 0 0 0 .926 0c.201-.202 4.918-5.005 4.918-9.103 0-1.882-.595-3.407-1.72-4.41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.2f0eca67.svg";
export { ForwardRef as ReactComponent };